import { createSelector, MemoizedSelector } from '@ngrx/store';
import { StateUtils } from '@spartacus/core';
import { TrackingDeliveryApi } from '@tracking/const';
import { StateWithTracking } from '../tracking-state';
import { getTrackingState } from './feature.selector';

export const getTrackingDeliveryDetailState: MemoizedSelector<
  StateWithTracking,
  StateUtils.EntityLoaderState<TrackingDeliveryApi>
> = createSelector(getTrackingState, (state) => state.trackingDelivery);

export const getTrackingDelivery = (
  trackingId: string,
): MemoizedSelector<StateWithTracking, StateUtils.LoaderState<TrackingDeliveryApi>> =>
  createSelector(getTrackingDeliveryDetailState, (state) => StateUtils.entityLoaderStateSelector(state, trackingId));

export const getTrackingDeliveryValue = (
  trackingId: string,
): MemoizedSelector<StateWithTracking, TrackingDeliveryApi> =>
  createSelector(getTrackingDeliveryDetailState, (state) => StateUtils.entityValueSelector(state, trackingId));

export const getTrackingDeliveryLoading = (trackingId: string): MemoizedSelector<StateWithTracking, boolean> =>
  createSelector(getTrackingDeliveryDetailState, (state) => StateUtils.entityLoadingSelector(state, trackingId));

export const getTrackingDeliveryError = (trackingId: string): MemoizedSelector<StateWithTracking, boolean> =>
  createSelector(getTrackingDeliveryDetailState, (state) => StateUtils.entityErrorSelector(state, trackingId));

export const getTrackingDeliverySuccess = (trackingId: string): MemoizedSelector<StateWithTracking, boolean> =>
  createSelector(getTrackingDeliveryDetailState, (state) => StateUtils.entitySuccessSelector(state, trackingId));
